import { jsx } from "react/jsx-runtime";
import "../../../../../external/luxon/src/duration.js";
import Info from "../../../../../external/luxon/src/info.js";
import "../../../../../external/luxon/src/impl/regexParser.js";
import { CalendarButton } from "../CalendarButton.js";
import { Scrollbar } from "../../../../Scrollbar/Scrollbar.js";
import { DATA_TEST_ID_INHERITED } from "../../../../../constants/DATA_TEST_ID_INHERITED.js";
import { inheritDataTestId } from "../../../../../utils/dataTestId.js";
const MonthsSelector = ({ selected, onChange, disableMonthTo, disableMonthFrom, ...props }) => {
  const months = Info.months("long");
  return /* @__PURE__ */ jsx(
    Scrollbar,
    {
      "data-test-id": DATA_TEST_ID_INHERITED,
      sx: styles.container,
      color: "dark",
      ...props,
      children: months.map((month, i) => {
        const disabled = (disableMonthFrom ? i + 1 >= disableMonthFrom : !1) || (disableMonthTo ? i + 1 <= disableMonthTo : !1);
        return /* @__PURE__ */ jsx(
          CalendarButton,
          {
            variant: "common",
            selected: selected === i + 1,
            id: selected ? `selected_${month}` : void 0,
            onClick: () => onChange(i + 1),
            disabled,
            "data-test-id": inheritDataTestId(props, `month-button${i}`),
            children: month
          },
          month
        );
      })
    }
  );
}, styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    rowGap: 6,
    paddingY: 6
  }
};
export {
  MonthsSelector
};
//# sourceMappingURL=MonthsSelector.js.map
